import * as React from 'react';
import { PolicySubTypeTCEnum } from '../../store/details/policy/types';
import styles from './insurance-logo.module.css';

interface Props {
  readonly policySubTypeTC: string;
  readonly languageTC: string;
}

export class InsuranceLogo extends React.PureComponent<Props> {
  render() {
    switch (this.props.policySubTypeTC) {
      case PolicySubTypeTCEnum.BELFIUS_HOME:
        return <img alt="" src={require('../../assets/images/belfius_logo_218x46.png')} className={styles.logo} />;
      case PolicySubTypeTCEnum.DVV_BRAND:
        if (this.props.languageTC === 'nl-BE') {
          return <img alt="" src={require('../../assets/images/dvv_nl.png')} className={styles.logo} />;
        } else {
          return <img alt="" src={require('../../assets/images/dvv_fr.png')} className={styles.logo} />;
        }
      default:
        return '';
    }
  }
}
